import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MigrationSniperWrapperComponent } from './components/migration-sniper-wrapper/migration-sniper-wrapper.component';
import { MigrationSniperRoutingModule } from './migration-sniper-routing.module';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MigrationSniperListComponent } from './components/migration-sniper-list/migration-sniper-list.component';
import { PeanutUiModule } from '@shared/modules/peanut-ui/peanut-ui.module';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ReactiveFormsModule } from '@angular/forms';
import { TenantsService } from '../tenants/services/tenants.service';
import { MigrationSniperService } from './migration-sniper.service';
import { NzTableModule } from 'ng-zorro-antd/table';
import { IconsModule } from '@shared/modules/icons/icons.module';
import { StatusLabelModule } from '@shared/components/status-label/status-label.module';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { PipeModule } from '@pipes';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';

@NgModule({
    declarations: [MigrationSniperWrapperComponent, MigrationSniperListComponent],
    imports: [
        CommonModule,
        MigrationSniperRoutingModule,
        NzButtonModule,
        NzInputModule,
        NzIconModule,
        PeanutUiModule,
        NzFormModule,
        NzSelectModule,
        ReactiveFormsModule,
        NzTableModule,
        IconsModule,
        StatusLabelModule,
        NzTooltipModule,
        PipeModule,
        NzPopconfirmModule,
    ],
    providers: [TenantsService, MigrationSniperService],
})
export class MigrationSniperModule {}
